export const onChangeDashboardAction = (props: any) => {
	const { setValue } = props;
	// eslint-disable-next-line no-underscore-dangle
	const formValues = props?.control?._formValues;
	let { expName } = formValues;
	const { mapValue } = formValues;
	const parsedMapValue = JSON.parse(mapValue);
	let bucketSupportedList = [];
	const experimentList = Object.keys(parsedMapValue);
	experimentList.forEach((experiment: string) => {
		if (experiment === expName) expName = experiment;
	});
	bucketSupportedList = parsedMapValue[expName];
	setValue('bucketSupportedList', bucketSupportedList);
};

export const onChangeConfigValAction = (props: any) => {
	const { setValue, name } = props;
	const stringVal = document.getElementsByName(name)[0].value?.replace(/,/g, '');
	if (!Number.isNaN(stringVal)) {
		const val = Number(stringVal);
		setValue(name, val?.toLocaleString('en-IN'));
	}
};
